import { IntegrationPartner } from "refsix-js-models";

export function integrationPartnerName(partner: IntegrationPartner): string {
    switch (partner) {
        case IntegrationPartner.dbu:
            return "DBU";
        case IntegrationPartner.stack:
            return "Stack Sports";
        case IntegrationPartner.refassist:
            return "RefAssist";
        case IntegrationPartner.assignr:
            return "Assignr";
        case IntegrationPartner.knvb:
            return "KNVB";
        case IntegrationPartner.refinsight:
            return "Ref Insight";
        case IntegrationPartner.soccerRefManager:
            return "SoccerRefManager";
        case IntegrationPartner.arbiter:
            return "Arbiter Sports";
        case IntegrationPartner.moas:
            return "MOAS";
        default:
            return partner;
    }
}
